<template>
  <div class="page-pointModal" @click="handleCancel()">
    <div class="case">
      <div class="icons">
        <img class="casePng" src="./../../assets/treat/case.png" alt />
      </div>
      <img class="fingerPng" src="./../../assets/treat/finger.gif" alt />
    </div>
    <div class="content">
      <div class="content-box">
        <div>根据您的答题选择，</div>
        <div>病例记录会实时更新，</div>
        <div>可随时点击右上方图标查看病例记录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "pointModal",
  data() {
    return {
      lightImage: require("./../../assets/treat/lightRound.png")
    };
  },
  computed: {
    ...mapState("visualExamination", ["submitFlag"])
  },
  watch: {},
  created() {},
  methods: {
    ...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
    //关闭弹框
    handleCancel() {
      this.VISUAL_EXAMINATION({ key: "submitFlag", value: false });
    }
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.page-pointModal {
  width: 100%;
  min-height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(#000, 0.5);
  z-index: 1;
  .case {
    width: 100%;
    .icons{
      position: absolute;
      top: 10px;
      right: 10px;
      padding: 30px;
      background: #99d1d9;
      border-radius: 50%;
      z-index: 2;
      padding: 30px;
    }
    .casePng {
      width: 93px;
      height: 93px;
    }
    .fingerPng {
      width: 200px;
      // height: 107px;
      position: absolute;
      transform: rotate(90deg);
      left: 500px;
      top: 100px;
      z-index: 3;
    }
  }
  .content {
    display: flex;
    justify-content: center;
    .content-box {
      width: 665px;
      height: 642px;
      background: #ffffff;
      box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
      opacity: 0.85;
      border-radius: 60px;
      margin-top: 320px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    div {
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #333333;
      line-height: 60px;
    }
  }
}
</style>
